import React, { useEffect, useState, useRef, useCallback } from 'react';
import SignatureCanvas from './SignatureCanvas';
import { FaFilePdf, FaTrash } from 'react-icons/fa';

const UploadWithSignature = ({ onFilesChange }) => {
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);

    const processFiles = useCallback((selectedFiles) => {
        const processedFiles = selectedFiles.map(file => {
            const id = Date.now() + Math.random().toString(36).substr(2, 9);

            if (file.type.startsWith("image/")) {
                return {
                    id,
                    file,
                    type: 'image',
                    src: URL.createObjectURL(file),
                    signatureData: null
                };
            } else if (file.type === 'application/pdf') {
                return {
                    id,
                    file,
                    type: 'pdf',
                    src: null // We don't need preview URL for PDF
                };
            }
            return null;
        }).filter(Boolean);

        setFiles(prev => [...prev, ...processedFiles]);
    }, []);

    const clearSignature = useCallback((fileId) => {
        setFiles(prev =>
            prev.map(f =>
                f.id == fileId && f.type == 'image' ? { ...f, signatureData: null } : f
            )
        );
    }, []);

    const saveSignature = useCallback((fileId, signatureData) => {
        setFiles(prev =>
            prev.map(f =>
                f.id == fileId && f.type == 'image' ? { ...f, signatureData } : f
            )
        );
    }, []);

    const removeFile = useCallback((fileId) => {
        setFiles(prev => {
            const updated = prev.filter(f => {
                if (f.id == fileId) {
                    if (f.type == 'image') {
                        URL.revokeObjectURL(f.src);
                    }
                    return false;
                }
                return true;
            });
            return updated;
        });
    }, []);

    useEffect(() => {
        onFilesChange(
            files.map(f => ({
                originalFile: f.file,
                signatureData: f.signatureData
            }))
        );
    }, [files, onFilesChange]);

    useEffect(() => {
        return () => {
            files.forEach(file => {
                if (file.type == 'image') {
                    URL.revokeObjectURL(file.src);
                }
            });
        };
    }, [files]);

    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        processFiles(droppedFiles);
    };

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        processFiles(selectedFiles);
        e.target.value = '';
    };

    return (
        <div className="fieldset">
            <h1>Upload</h1>
            <div className="formsBox upload-container">
                <div
                    className="drop-zone"
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={handleDrop}
                >
                    <p>Drag & Drop Images or PDFs Here</p>
                    <p>or</p>
                    <button
                        type="button"
                        onClick={() => fileInputRef.current.click()}
                        className="select-button btn btn-primary"
                    >
                        Select Files
                    </button>
                    <input
                        type="file"
                        accept="image/*,.pdf"
                        multiple
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        hidden
                    />
                </div>
            </div>

            <div className="filesList">
                {files.map((file) => (
                    <>
                        {file.type === 'image' ? (
                            <SignatureCanvas
                                key={file.id}
                                file={file}
                                onRemove={removeFile}
                                saveSignature={saveSignature}
                                clearSignature={clearSignature}
                            />
                        ) : null}
                    </>
                ))}
            </div>
            <div className="filesList">
                {files.map((file) => (
                    <>
                        {file.type !== 'image' ? (
                            <div key={file.id} className="filepdfitem">
                                <div className="pdfitem">
                                    <div className="pdf-icon">
                                        <FaFilePdf size={48} color="#e74c3c" />
                                    </div>
                                    <div className="file-info">
                                        <div className="file-name">{file.file.name}</div>
                                    </div>
                                    <button onClick={() => removeFile(file.id)} className="remove-btn"> <FaTrash /></button>
                                </div>
                            </div>
                        ) : null}
                    </>
                ))}
            </div>
        </div>
    );
};

export default React.memo(UploadWithSignature);